import { CardSection, Flex } from '@/lib/v2/components';

import { RulesEmailAction } from './RulesEmailAction';

const RulesEmailMain = () => {
  //TODO: review this classes in automation: z-0 w-full
  return (
    <div className="relative w-full bg-white">
      <CardSection noPadding>
        <Flex column>
          <RulesEmailAction />
        </Flex>
      </CardSection>
    </div>
  );
};

export default RulesEmailMain;
